export class AddRevenue {
    public constructor(init?: Partial<AddRevenue>) {
      Object.assign(this, init);
    }
        lotNumber: string;
        invoiceNumber: string;
        revenueType: string;
        revenueTypeName: string;
        billingRate: number;
        quantity: number;
        sequenceStart: string;
        sequenceEnd: string;
        comments: string;
        userName: string;
        description: string;
        isTaxable: boolean;
        taxAmount: number;
        totalRevenue:number;
        netRevenue: number;
   }